import {
    Create,
    required,
    TextInput,
    BooleanInput,
    Link,
    useCreate,
    useNotify,
    useRedirect, TabbedForm, FormTab, NumberInput, minValue, FunctionField
} from "react-admin";
import * as React from "react";
import {useEffect, useRef, useState} from "react";
import {EBooleanStatuses, EBooleanStatusesNumber} from "../../../Const/Enums";
import {useDispatch} from "react-redux";
import setLoadStatus from "../../../Store/LoaderReducer";
import {Calendar} from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import {convertedDate, convertedDateWithTime} from "../../../Functions/ConvertedDate";

export const CreateEventHistory = () => {
    const initialRef = useRef(true);
    const [create] = useCreate();
    const notify = useNotify();
    const redirect = useRedirect();
    const dispatch = useDispatch();

    const onDateChange = (e, period) => {
        if (e.value && e.value.unix) {
            const date = new Date(e.value.unix * 1000);
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            formData[period] = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${hours}:${minutes}`;
        }
    }

    const validateUserCreation = async (values) => {
        const errors = {};
        console.log("valuesvaluesvaluesvaluesvalues");
        console.log(values);


        if (!values.start_date.length) {
            errors.start_date = 'Start date is required';
        }

        if (!values.end_date.length) {
            errors.end_date = 'End date is required';
        }


        console.log(errors);


        return errors
    };

    const [formData] = useState({
        name: '',
        description: '',
        start_date: '',
        end_date: '',
        order: 0,
        published: false
    });

    useEffect(() => {
        if (!initialRef.current) {
            return;
        }
        initialRef.current = false;
    }, [])

    const fileCreate = () => {
        let startDate = formData.start_date || document.getElementById('start_date').value;
        let endDate = formData.end_date || document.getElementById('end_date').value;

        if(!startDate.length) {
            notify('Start date is required', 'warning');
            return ;
        }

        if(!endDate.length) {
            notify('End date is required', 'warning');
            return ;
        }

        if(startDate.length && endDate.length) {
            let startD = new Date(startDate);
            let endD = new Date(endDate);
            if (startD.getTime() > endD.getTime()) {
                notify("Start date can't be earlier than end date", 'warning');
                return ;
            }
        }

        if (!formData.name.length || formData.order <= 0) {
            if (!formData.name.length) {
                document.querySelector('.name').classList.add('error');
            }

            if (formData.order <= 0) {
                document.querySelector('.order').classList.add('error');
            }

            return;
        }

        dispatch(setLoadStatus(true));

        create('event-histories/general', {data: {
                name: formData.name,
                start_date: startDate,
                end_date: endDate,
                description: formData.description,
                order: formData.order,
                published: formData.published ? EBooleanStatusesNumber.True : EBooleanStatusesNumber.False,
            }}, {
            onSuccess: (res) => {
                dispatch(setLoadStatus(false));
                redirect(`/event-histories/general/${res.id}/en`);
                notify('Event created');
            },
            onError: (res) => {
                dispatch(setLoadStatus(false));
                notify(res.message, 'warning');
            }
        });
    };

    const Save = () => {
        return (
            <div className="dailyActionToolbar">
                <Link to="/event-histories/general" className="button bar-purple-button">Cancel</Link>
                <button
                    onClick={fileCreate}
                    className="button bar-gradient-button"
                    type="button"
                >
                    <span>Save</span>
                </button>
            </div>
        );
    }

    const nameChange = (e) => {
        if (document.querySelector('.name').classList.contains('error')) {
            document.querySelector('.name').classList.remove('error');
        }
        formData.name = e.target.value;
    }

    const orderChange = (e) => {
        const val = +e.target.value;
        if (val <= 0) {
            document.querySelector('.order').classList.add('error');
            return;
        }
        if (document.querySelector('.order').classList.contains('error')) {
            document.querySelector('.order').classList.remove('error');
        }
        formData.order = val;
    }

    return (
        <>
            <h2 className="dailyTitle">New Event</h2>
            <Create title="Event">
                <TabbedForm className="tabbedForm" record={formData} toolbar={<></>}>
                    <FormTab  label="General">
                        <div className="tabbedFormWrap">
                            <TextInput className="formFields name" label="Name" name="name" source="formData.name" fullWidth id="name" validate={required()} onChange={(e) => {nameChange(e)}} multiline />
                            <p className="required-text">Required</p>
                            <TextInput className="formFields" label="Description" name="description" source="formData.description" id="description" multiline fullWidth onChange={(e) => {formData.description = e.target.value}} />
                            <NumberInput label="Order" name="order" source="order" min={1} className="numberInput order" fullWidth id="order" validate={[required(), minValue(1)]} onChange={(e) => {orderChange(e)}} />
                            <p className="required-text">Must be at least 1</p>
                            <BooleanInput label="Visible" name="published" source="formData.published" className="booleanInput" defaultValue={EBooleanStatuses.False} onChange={(e) => {formData.published = e.target.checked}}/>
                            <span className="showDateLabel">Start Date</span>
                            <FunctionField source="start_date" render={(record) => {
                                return (
                                    <>
                                        <Calendar
                                            value={record.start_date ? convertedDateWithTime(record.start_date) : null}
                                            onPropsChange={(e) => {
                                                onDateChange(e, 'start_date')
                                            }}
                                            format="MM/DD/YYYY HH:mm"
                                            plugins={[<TimePicker position="bottom" hideSeconds />]}
                                            minDate="2000/01/01"
                                            maxDate="3000/12/31"
                                        />
                                        <input type="hidden" id="start_date"
                                               value={record.start_date && !formData.start_date ? convertedDate(record.start_date) : formData.start_date}/>
                                    </>
                                );
                            }}/>
                            <span className="showDateLabel showDateLabelEnd">End Date</span>
                            <FunctionField source="end_date" render={(record) => {
                                return (
                                    <>
                                        <Calendar
                                            value={record.end_date ? convertedDateWithTime(record.end_date) : null}
                                            onPropsChange={(e) => {
                                                onDateChange(e, 'end_date')
                                            }}
                                            format="MM/DD/YYYY HH:mm"
                                            plugins={[<TimePicker position="bottom" hideSeconds />]}
                                            minDate="2000/01/01"
                                            maxDate="3000/12/31"
                                        />
                                        <input type="hidden" id="end_date"
                                               value={record.end_date && !formData.end_date ? convertedDate(record.end_date) : formData.end_date}/>
                                    </>
                                );
                            }}/>
                        </div>
                        <Save />
                    </FormTab>
                    <FormTab label="EN" path="en" disabled={true}>
                        <>
                            <p>No Data</p>
                        </>
                    </FormTab>
                    <FormTab label="PT" path="pt" disabled={true}>
                        <>
                            <p>No Data</p>
                        </>
                    </FormTab>
                    <FormTab label="DE" path="de" disabled={true}>
                        <>
                            <p>No Data</p>
                        </>
                    </FormTab>
                </TabbedForm>
            </Create>
        </>
    );
}